module.exports = __webpack_public_path__ + "media/Vagabond's Pride.80eecdc4.mp3";